import { useEffect } from 'react'
import { useSetRecoilState } from 'recoil'
import equipmentAtom from '../../atoms/equipment.atom.ts'
import eventBus from '../../../../services/eventBus'
import recoilStateUpdaters from '../../../../recoil/recoil.stateUpdaters.ts'
import equipmentModelsAtom from '../../pages/EquipmentModels/equipmentModels.atom.ts'
import connectionRequestsAtom from '@/pages/Equipment/atoms/connectionRequests.atom.ts'

const useEquipmentEventsSubscriptions = () => {
  const setEquipmentState = useSetRecoilState(equipmentAtom)
  const setEquipmentModelsState = useSetRecoilState(equipmentModelsAtom)
  const setConnectionRequestsState = useSetRecoilState(connectionRequestsAtom)

  useEffect(() => {
    const createSub = eventBus.sub('equipment.created', (equipment) => {
      recoilStateUpdaters.itemCreated(setEquipmentState, equipment)
    })

    const updateSub = eventBus.sub('equipment.updated', (equipment) => {
      recoilStateUpdaters.itemUpdated(setEquipmentState, equipment)
    })

    const removeSub = eventBus.sub('equipment.deleted', (id) => {
      recoilStateUpdaters.itemDeleted(setEquipmentState, id)
    })

    const createModelSub = eventBus.sub('equipment.models.created', (model) => {
      recoilStateUpdaters.itemCreated(setEquipmentModelsState, model)
    })

    const updateModelSub = eventBus.sub('equipment.models.updated', (model) => {
      recoilStateUpdaters.itemUpdated(setEquipmentModelsState, model)
    })

    const removeModelSub = eventBus.sub('equipment.models.deleted', (id) => {
      recoilStateUpdaters.itemDeleted(setEquipmentModelsState, id)
    })

    const createConnectionRequestSub = eventBus.sub('equipment.connection-requests.created', (connectionRequest) => {
      recoilStateUpdaters.itemCreated(setConnectionRequestsState, connectionRequest)
    })

    return () => {
      createSub()
      updateSub()
      removeSub()
      createModelSub()
      updateModelSub()
      removeModelSub()
      createConnectionRequestSub()
    }
  }, [])
}

export default useEquipmentEventsSubscriptions
